<template>
  <div
    class="monitor"
    style="font-size: 16px; width: 100%; background: #eff1f5"
  >
    <div class="content">
      <div class="yuliang" ref="yuliang" style="margin-top: 0">
        <div class="select" ref="districtrainOperation">
          <span class="desc">起止时间:</span>
          <div style="display: inline-block">
            <el-date-picker
              v-model="query.begTime"
              format="yyyy-MM-dd HH:00"
              value-format="yyyy-MM-dd HH:00"
              type="datetime"
              placeholder="选择开始时间"
              :clearable="false"
              :editable="false"
              :picker-options="Global.pickerOptionsStart(query.endTime)"
            ></el-date-picker>
            <span class="desc">至</span>
            <el-date-picker
              v-model="query.endTime"
              format="yyyy-MM-dd HH:00"
              value-format="yyyy-MM-dd HH:00"
              type="datetime"
              placeholder="选择结束时间"
              :clearable="false"
              :editable="false"
              :picker-options="Global.pickerOptionsEnd(query.begTime)"
            ></el-date-picker>
          </div>
          <span id="select" @click="searchData">查询</span>
          <span id="export" @click="exportExcel">
            <span class="export-icon"></span>导出
          </span>
        </div>
        <div class="tableDiv" ref="tableDiv">
          <el-table
            v-loading="loading"
            highlight-current-row
            :data="tdata"
            border
            :height="height"
            style="width: 100%"
          >
            <el-table-column
              type="index"
              width="70"
              label="序号"
              align="center"
              header-align="center"
            >
            </el-table-column>
            <el-table-column
              prop="name"
              align="center"
              header-align="center"
              label="乡镇"
              min-width="120"
              sortable
            >
            </el-table-column>
            <el-table-column
              prop="value"
              align="center"
              header-align="center"
              label="面雨量(mm)"
              min-width="110"
              sortable
            >
            </el-table-column>
            <el-table-column
              prop="maxStation"
              align="center"
              header-align="center"
              label="累计最大雨量站点"
              min-width="120"
            >
            <template slot-scope="scope">
                 {{scope.row.maxStation === undefined ? '--':scope.row.maxStation}}
            </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="bottom-table">
          <table>
            <tbody>
              <tr>
                <td colspan="2">全县面雨量</td>
                <td>{{ allCityRain }}mm</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import reportAnalysisTypes from '@/store/types/reportAnalysis'
import timer from '@/utils/timer'
export default {
  data () {
    return {
      loading: true,
      timerFun: '',
      query: {
        addvcd: '330324',
        begTime: '',
        endTime: ''
      },
      allCityRain: '',
      tdata: [],
      height: 10
    }
  },
  methods: {
    searchData () {
      this.tabledata()
    },
    tabledata () {
      this.loading = true
      // let startTime = new Date(this.query.begTime.getTime() + 8 * 3600)
      // let endTime = new Date(this.query.endTime.getTime() + 8 * 3600)
      this.$store
        .dispatch(reportAnalysisTypes.GET_AREA_RAINFALL_RAIN, {
          sID: '22',
          addvcd: this.query.addvcd,
          beginTime: this.query.begTime,
          endTime: this.query.endTime
        })
        .then(data => {
          this.allCityRain = data.avgRain // 全县面雨量
          this.tdata = this.concatMaxStation(data.townRain, data.stationRain)
          this.loading = false
        })
    },
    exportExcel () {
      // let startTime = new Date(this.query.begTime.getTime() + 8 * 3600)
      // let endTime = new Date(this.query.endTime.getTime() + 8 * 3600)
      this.$store
        .dispatch(reportAnalysisTypes.EXPORT_AREA_RAINFALL_RAIN, {
          sID: '22',
          beginTime: this.query.begTime,
          endTime: this.query.endTime
        })
        .then((data) => {
          // console.log('333', data)
          // window.location.href = data
          // this.loading = false
          let blob = new Blob([data], { type: 'application/vnd.ms-excel' })
          let fileName = Date.parse(new Date()) + '.xls'
          var link = document.createElement('a')
          link.href = window.URL.createObjectURL(blob)
          link.download = fileName
          link.click()
          window.URL.revokeObjectURL(link.href)// 释放内存
          this.loading = false
        })
    },
    concatMaxStation (town, station) {
      for (let i = 0; i < town.length; i++) {
        if (town[i].maxStationValue === 0) {
          // 最大雨量为0则不显示
          town[i].maxStation = undefined
        } else {
          // 若多个相同的最大雨量，则一同显示
          let max = station.filter(x => parseFloat(x.value) === town[i].maxStationValue &&
            x.addvnm === town[i].name)
          town[i].maxStation = max.map(x => x.name + '：' + x.value).join('，')
        }
      }
      return town
    },
    getTime () {
      let date = new Date()
      let preDate
      if (date.getHours() < 8) {
        preDate = new Date(date.getTime() - 24 * 60 * 60 * 1000)
        this.query.begTime = this.$moment(preDate).format('YYYY-MM-DD 00:00')
      } else {
        this.query.begTime = this.$moment(preDate).format('YYYY-MM-DD 08:00')
      }
      this.query.endTime = this.$moment(date).format('YYYY-MM-DD HH:mm')
    }
  },
  mounted () {
    this.getTime()
    this.tabledata()
    this.timerFun = setInterval(() => {
      this.getTime()
      this.tabledata()
    }, timer.TIMER_MIN)
    this.$nextTick(() => {
      let contentDiv = document.getElementsByClassName('content')
      this.$refs['yuliang'].style.height =
        contentDiv[0].offsetHeight - 30 + 'px'
      this.$refs['tableDiv'].style.height =
        this.$refs['yuliang'].offsetHeight -
        110 -
        this.$refs['districtrainOperation'].offsetHeight +
        'px'
      this.height = this.$refs['tableDiv'].style.height
      // this.$refs['thead'].style.width = this.$refs['tbody'].offsetWidth + 'px'
      // this.$refs['tbody'].style.height =
      // this.$refs['tableDiv'].offsetHeight - this.$refs['thead'].offsetHeight + 'px'
    })
  },
  beforeDestroy () {
    clearInterval(this.timerFun)
  }
}
</script>
<style lang="less" src="@/assets/monitor.less" scoped>
</style>
<style lang="less" scoped>
.monitor {
  overflow: hidden;
  // .tableDiv {
  //   color: #000;
  //   margin-top: 5px;
  //   width: 98%;
  //   margin-left: 1%;
  //   overflow: scroll;
  // }
   .tableDiv{
        margin-top: 5Px;
        width:98%;
        margin-left: 1%;
        overflow: auto;
      }
        /* 样式穿透 */
      .tableDiv /deep/ .el-table th>.cell{
        // text-align: center !important;
        font-family: Microsoft YaHei UI !important;
        font-size: 15px !important;
        color: #333333 !important;
      }
      .tableDiv /deep/ .el-table td>.cell{
        // text-align: center !important;
        font-family: Microsoft YaHei UI !important;
        font-size: 15px !important;
        color: #666666 !important;
      }
      .tableDiv /deep/ .el-table tr:nth-child(even) {
        background: #eaf1fa;
      }
      .tableDiv /deep/ .el-table th {
        background: #F5F7FA!important;
        width: 50px;
      }
  .bottom-table {
    width: 98%;
    margin-left: 1%;
    margin-top: 20px;
    table {
      width: 100%;
      font-size: 15px;
      tbody {
        width: 100%;
        overflow-y: scroll;
        // display: block;
        height: 100px;
        > tr {
          display: table;
          width: 100%;
          table-layout: fixed;
          text-align: center;
          vertical-align: middle;
          height: 50px;
          td {
            border: 1px solid rgb(235, 239, 246);
          }
        }
      }
    }
  }
}
</style>
